'use client';

import { useCallback, useSyncExternalStore } from 'react';
import { tooltipStore } from '../stores/tooltipStore';

const subscribe = (onStoreChange: () => void) =>
  tooltipStore.subscribe(onStoreChange);

/**
 * Whether `id` is the active tooltip. Callers re-render only when that answer
 * flips, rather than on every tooltip store event.
 */
export function useIsOnboardingTooltipActive(id: string): boolean {
  const getSnapshot = useCallback(
    () => tooltipStore.getActiveTooltip()?.id === id,
    [id]
  );

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
